import axios from 'axios';
// import { slots, offices } from './respondStubs';

const BASE_URL = process.env.REACT_CIRCA_API_BASE_URL;

export default class CircaApi {

    static async getOffices (zipcode, country) {
        let response;
        try {
            response = await axios.post(`${BASE_URL}v1/offices-distance`, { zipcode: zipcode } );
        } catch (error) {
            console.error(error);
        }

        return response.data;
    }

    static async getSlots (dateFrom, dateTo, officeId) {
        let response;
        try {
            response = await axios.get(`${BASE_URL}v2/office/${officeId}/slots?date_from=${dateFrom}&date_to=${dateTo}` );
        } catch (error) {
            console.error(error);
        }

        if(Array.isArray(response.data.data) && response.data.data.length === 0){
            return {};
        }

        return response.data.data;
    }
}

CircaApi.offices = [];
